import React from "react";
import { FilePond, registerPlugin } from "react-filepond";
// Import the File Type Validation plugin
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import upload_green from "../assets/icons/upload_green.png";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Register the plugins
registerPlugin(
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginImageTransform
);

const Upload = ({
  maxFiles = 1,
  className = "audio-upload",
  labelClassname = "",
  labelIcon = upload_green,
  stylePanelAspectRatio = "1.2",
  stylePanelLayout = "integrated",
}) => {
  return (
    <div className="h-full w-full">
      <FilePond
        allowMultiple
        allowFileTypeValidation
        maxFiles={maxFiles}
        className={className}
        stylePanelAspectRatio={stylePanelAspectRatio}
        stylePanelLayout={stylePanelLayout}
        fileValidateTypeLabelExpectedTypes="Supported format: ZIP"
        acceptedFileTypes={["application/x-zip-compressed", "application/zip"]}
        labelIdle={`<div class="audio-upload-label ${labelClassname}">
        <img src="${labelIcon}" height="48px" width="48px" />
        <div>Drag & Drop your files or <span class="filepond--label-action"> Browse </span><div>
        <span class="audio-supported-type-label">Supported format: ZIP</span>
      </div>`}
      />
    </div>
  );
};

export default Upload;
